import { MetadatiRepertorioDTO } from "./metadati-repertorioDTO";

export class DecretoDTO {
  oggetto: string;
  id: string;
  metadatiRepertorio: MetadatiRepertorioDTO;
  dataConclusione: string;
}
